<div
  #container
  [ngClass]="containerClass()"
  [class]="styleClass"
  [ngStyle]="style"
  [attr.data-pc-name]="'splitter'"
  [attr.data-p-gutter-resizing]="false"
  [attr.data-pc-section]="'root'"
>
  <ng-template ngFor let-panel [ngForOf]="panels" let-i="index">
    <div
      [ngClass]="panelContainerClass(i)"
      [class]="panelStyleClass"
      [ngStyle]="panelStyle"
      tabindex="-1"
      [attr.data-pc-name]="'splitter'"
      [attr.data-pc-section]="'root'"
    >
      <ng-container *ngTemplateOutlet="panel"></ng-container>
    </div>

    <!-- After every panel add a resizing gutter -->
    <div
      *ngIf="maxPanelIndex == -1 && i !== panels.length - 1"
      [class]="splitterGutterClass()"
      role="separator"
      tabindex="-1"
      (mousedown)="onGutterMouseDown($event, i)"
      (touchstart)="onGutterTouchStart($event, i)"
      (touchmove)="onGutterTouchMove($event)"
      (touchend)="onGutterTouchEnd($event, i)"
      [attr.data-p-gutter-resizing]="false"
      [attr.data-pc-section]="'gutter'"
    >
      <div
        class="handle-container"
        tabindex="0"
        [attr.aria-orientation]="layout"
        [attr.aria-valuenow]="prevSize"
        [attr.data-pc-section]="'gutterhandle'"
        (keyup)="onGutterKeyUp($event)"
        (keydown)="onGutterKeyDown($event, i)"
      >
        <div class="indicator"></div>
        <div class="indicator"></div>
      </div>
    </div>
  </ng-template>
</div>
